import React from 'react'
import PropTypes from 'prop-types'

import app from 'common/builder/components/chart/FlowChart/app'

export default function withIsHover(BaseComponent) {
  return class PositionProvider extends React.PureComponent {
    static propTypes = {
      id: PropTypes.string,
    }

    state = {
      isHover: false,
    }

    componentDidMount() {
      app.on('hover', this.handleAppHoverChanged)
      this.handleInitialization()
    }

    componentDidUpdate(prevProps, prevState) {
      if (prevProps.id !== this.props.id) {
        this.handleInitialization()
      }
    }

    componentWillUnmount() {
      app.removeListener('hover', this.handleAppHoverChanged)
    }

    checkHover = (node) => {
      const { id } = this.props
      const isHover = id != null && node != null && node.id === id
      if (isHover !== this.state.isHover) {
        this.setState({ isHover })
      }
    }

    handleInitialization = () => {
      this.checkHover(app.getHoveredNode())
    }

    handleAppHoverChanged = (node) => {
      this.checkHover(node)
    }

    render() {
      return <BaseComponent {...this.props} isHover={this.state.isHover} />
    }
  }
}
